module.exports = __webpack_public_path__ + "6c3877898e39f3cf9044e80df76e7c0d.ttf";